import React, { useEffect, useState } from "react";
import "../styles/representative.css";
import translations from "./translations";
import { useLanguage } from "./Context/LanguageContext";

function Representative() {
  const [representativesList, setRepresentativesList] = useState([]);
  const { language } = useLanguage();

  useEffect(() => {
    getRepresentativesList();
  }, []);

  // Fetch representative data from the local API endpoint
  async function getRepresentativesList() {
    try {
      const response = await fetch(
        "https://cairomed-backend.vercel.app/api/representatives/getRepresentatives"
      );
      if (!response.ok) {
        throw new Error("Failed to fetch representatives data");
      }
      const data = await response.json();
      setRepresentativesList(data);
      console.log(data);
    } catch (error) {
      console.error("Error fetching representatives:", error);
    }
  }

  return (
    <>
      <main id="representative">
        <section className="page-header">
          <div className="container">
            <div>
              <h1>{translations[language].heroSectionTitle}</h1>
              <h2>{translations[language].repHeaderTitle}</h2>
              <p>
                {translations[language].repHeaderParagraph}
              </p>
              <p>
                {translations[language].repHeaderParagraph2}
              </p>
            </div>
          </div>
        </section>
        <div className="representative-container container mt-7">
          {representativesList.map((representative) => {
            return (
              <div
                className="representative-card mb-3"
                key={representative._id}
              >
                <picture>
                  <img
                    src={representative.Image || "fallback-image.jpg"}
                    className="card-img-top cardImg"
                    alt={representative.NameEN || "Representative"}
                  />
                </picture>
                <div className="representative-card-content">
                  <div>
                    <i className="fa-regular fa-address-card cardText"></i>
                      <span>{translations[language].cardNameLabel}:</span>
                    <p>
                      {language === 'en' ? representative.NameEN : representative.NameAR || "N/A"}
                    </p>
                  </div>
                  <div>
                    <i className="fa-solid fa-phone cardText"></i>
                      <span>{translations[language].cardPhoneLabel}:</span>
                    <p>
                      {representative.PhoneNumber || "N/A"}
                    </p>
                  </div>
                  <div>
                    <i className="fa-solid fa-location-dot cardText"></i>
                      <span>{translations[language].cardRegionLabel}:</span>
                    <p>
                      {language === 'en' ? representative.AreaEN : representative.AreaAR || "N/A"}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </main>
    </>
  );
}

export default Representative;
